import {ChargingPaymentMethodInterface} from '../interfaces/charging-payment-method.interface';

export class SetSubscriptionPaymentMethodAction {
  static readonly type = '[Payment] Set subscription payment method';

  constructor(public paymentMethod: ChargingPaymentMethodInterface) {
  }
}
